/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverfit1Inputs */

const en_coverfit1 = /** @type {(inputs: Coverfit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fit to cover with AI`)
};

const de_coverfit1 = /** @type {(inputs: Coverfit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit KI ans Titelbild anpassen`)
};

/**
* | output |
* | --- |
* | "Fit to cover with AI" |
*
* @param {Coverfit1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverfit1 = /** @type {((inputs?: Coverfit1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverfit1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverfit1(inputs)
	return de_coverfit1(inputs)
});
export { coverfit1 as "coverFit" }